export { default as Spacer } from './component';
export { useSpacer } from './hook';
export type { Props as SpacerProps } from './types';
